import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationDecoteRetourExclus } from 'store/administration/administrationActions';
import { postDecoteRetourExclu } from 'store/administration/administrationActions';
import { deleteDecoteRetourExclu } from 'store/administration/administrationActions';
import AdministrationDecoteRetourExclus from './AdministrationDecoteRetourExclus';
import withLoader from 'components/Shared/withLoader';

const AdministrationDecoteRetourExclusWithLoader = withLoader(AdministrationDecoteRetourExclus);

class AdministrationDecoteRetourExclusContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addDecoteRetourExcluDialogOpen: false,
            deleteDecoteRetourExcluDialogOpen: false,
            decoteRetourExcluToDelete: null,
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationDecoteRetourExclus();
    }

    handleOpenAddDialog = () => {
        this.setState({
            addDecoteRetourExcluDialogOpen: true
        });
    };
    

    handleCloseAddDialog = () => {
        this.setState({
            addDecoteRetourExcluDialogOpen: false
        });
    };

    addDecoteRetourExclu = async (decoteRetourExclu) => {
        await this.props.postDecoteRetourExclu(decoteRetourExclu);
    };

    handleOpenDeleteDialog = (decoteRetourExcluId) => {
        this.setState({
            deleteDecoteRetourExcluDialogOpen: true,
            decoteRetourExcluToDelete: this.props.decoteRetourExclus.find(x => x.id === decoteRetourExcluId)
        });
    };

    handleCloseDeleteDialog = () => {
        this.setState({
            deleteDecoteRetourExcluDialogOpen: false,
            decoteRetourExcluToDelete: null
        });
    };

    deleteDecoteRetourExclu = async (decoteRetourExcluId) => {
        this.setState({
            deleteDecoteRetourExcluDialogOpen: false
        });
        await this.props.deleteDecoteRetourExclu(decoteRetourExcluId);
    };

    render() {
        const { isLoading, niveaux, decoteRetourExclus } = this.props;

        return (
            <AdministrationDecoteRetourExclusWithLoader
                isLoading={isLoading}
                niveaux={niveaux}
                decoteRetourExclus={decoteRetourExclus}

                addDecoteRetourExcluDialogOpen={this.state.addDecoteRetourExcluDialogOpen}
                addDecoteRetourExclu={this.addDecoteRetourExclu}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}

                deleteDecoteRetourExcluDialogOpen={this.state.deleteDecoteRetourExcluDialogOpen}
                deleteDecoteRetourExclu={this.deleteDecoteRetourExclu}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                decoteRetourExcluToDelete={this.state.decoteRetourExcluToDelete}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let niveaux = state.administration.decoteRetourExclus.niveaux;
    let decoteRetourExclus = state.administration.decoteRetourExclus.items;

    // TODO decote par niveaux

    return {
        isLoading: state.administration.decoteRetourExclus.isLoading,
        niveaux: niveaux,
        decoteRetourExclus: decoteRetourExclus
    };
};

const mapDispatchToProps = {
    fetchAdministrationDecoteRetourExclus,
    postDecoteRetourExclu,
    deleteDecoteRetourExclu,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationDecoteRetourExclusContainer);